import { DialogsConfigService } from '@nrwl/dialog-configs';
import { Injectable } from '@angular/core';
import { RxTextCompositeComponent } from '@nrwl/rx-forms';
import { SignDialogComponent } from './sign-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class SignDialogService extends DialogsConfigService {
  constructor() {
    super();
  }

  public SignForm() {
    return {
      component: SignDialogComponent,
      panelClass: 'sign-dialog',
      hideHeader: true,
      payload: {
        title: 'Sign Form',
        subTitle: '-',
        signature: '',
      },
    };
  }

  public ConfirmSubmit() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Submit Form?',
        tip: 'Please review your form and confirm that all data is correct.<br/><br/>Once you pressed "Submit", the form will be submitted to your provider.',
        buttons: this.SubmitDismissButtons('Submit', 'Review'),
      },
    };
  }

  public ValidationError() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Alert',
        tip: 'Please fill in all the required fields.',
        disableClose: false,
        buttons: this.DismissButton('Review'),
      },
    };
  }
}
